var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen",
          value: _vm.loading,
          expression: "loading",
          modifiers: { fullscreen: true }
        }
      ],
      staticClass: "app-main-content",
      attrs: {
        "element-loading-text": "Loading...",
        "element-loading-spinner": "el-icon-loading"
      }
    },
    [
      _c(
        "div",
        { staticClass: "tabs-container" },
        [
          _vm.showView
            ? _c(
                "el-tabs",
                {
                  staticStyle: { width: "100%", height: "100%" },
                  attrs: { type: "card" },
                  model: {
                    value: _vm.activeTabName,
                    callback: function($$v) {
                      _vm.activeTabName = $$v
                    },
                    expression: "activeTabName"
                  }
                },
                [
                  _vm.singleReleaseVerifyViewHbl
                    ? _c(
                        "el-tab-pane",
                        {
                          staticStyle: { width: "100%", height: "100%" },
                          attrs: {
                            lazy: true,
                            label: _vm.$t("CargoMsg.Cargo_BLReleaseReview"),
                            name: "singleReleaseVerifyViewHbl"
                          }
                        },
                        [
                          _c("single-release-verify-view-hbl", {
                            attrs: {
                              "tab-name": "singleReleaseVerifyViewHbl",
                              "tab-title": _vm.$t(
                                "CargoMsg.Cargo_BLReleaseReview"
                              )
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.hblSingleReleaseView
                    ? _c(
                        "el-tab-pane",
                        {
                          staticStyle: { width: "100%", height: "100%" },
                          attrs: {
                            lazy: true,
                            label: _vm.$t("CargoMsg.Cargo_BLReleaseManagement"),
                            name: "hblSingleReleaseView"
                          }
                        },
                        [
                          _c("hbl-single-release-view", {
                            attrs: {
                              "tab-name": "hblSingleReleaseView",
                              "tab-title": _vm.$t(
                                "CargoMsg.Cargo_BLReleaseManagement"
                              )
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }